module.exports = __webpack_public_path__ + "static/cuervo-azabache-con-hongos_acrylic-mixed-media-diptych-8x12in-b6d5c9e5ceac3f4067ab902a1d4d3e53.jpg";